<template>
  <div class="page">
    <div class="pageL">
      <div class="pageTitle">宠物信息</div>
      <div class="view">
        <!-- action="https://res.huashengchongwu.com/api/media/oss/upload?dir=petImg" -->
        <!-- http://testres.huashengchongwu.com/ -->
        <el-upload class="avatar-uploader" action="http://testres.huashengchongwu.com/api/media/oss/upload?dir=petImg"
          :show-file-list="false" :http-request="uploadCoverImg">
          <el-image v-if="cover" :src="cover" class="avatar" :fit="cover"></el-image>
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
        <div class="viewR">
          <div class="petName">
            <div class="comName">宠物昵称</div>
            <div class="colon">:</div>
            <el-input placeholder="请输入宠物昵称" v-model="insideName" clearable size="small" style="flex: 1"
              :disabled="true"></el-input>
          </div>
          <div class="com1">
            <div class="comL">
              <div class="comName">种类</div>
              <div class="colon">:</div>
              <el-radio-group v-model="applyType" @change="applyTypeChange" :disabled="!$buttonAuthority('huoti-zongcang-message')
            ">
                <el-radio :label="1">猫</el-radio>
                <el-radio :label="2">狗</el-radio>
              </el-radio-group>
            </div>
            <div class="comR">
              <div class="comName">性别</div>
              <div class="colon">:</div>
              <el-radio-group v-model="sex" @change="sexChange"
                :disabled="!$buttonAuthority('huoti-zongcang-message') || tab == 0">
                <el-radio :label="0">未选择</el-radio>
                <el-radio :label="1">公</el-radio>
                <el-radio :label="2">母</el-radio>
              </el-radio-group>
            </div>
          </div>
        </div>
      </div>

      <div class="com2">
        <div class="comL">
          <div class="comName2">出生日期</div>
          <div class="colon">:</div>
          <el-date-picker v-model="bronDate" type="date" @change="bronChange" placeholder="选择日期" size="small"
            style="width: 164px"
            :picker-options="{ disabledDate(time) { return time.getTime() >= (new Date().getTime() - 15 * 86400000) } }"
            :disabled="!$buttonAuthority('huoti-zongcang-message') || tab == 0"></el-date-picker>
        </div>
        <div class="comR">
          <div class="comName2">品种</div>
          <div class="colon">:</div>
          <el-select v-model="breed" clearable placeholder="请选择品种" size="small" style="width: 164px"
            @change="breedChange" :disabled="!$buttonAuthority('huoti-zongcang-message')">
            <el-option v-for="item in breedOptions" :key="item._id" :label="item.name" :value="item._id"></el-option>
          </el-select>
        </div>
      </div>
      <div class="com2" v-if="breed != ''">
        <div class="comL">
          <div class="comName2">颜色</div>
          <div class="colon">:</div>
          <el-select v-model="color" clearable placeholder="请选择颜色" size="small" style="width: 164px"
            @change="colorChange" :disabled="!$buttonAuthority('huoti-zongcang-message')">
            <el-option v-for="item in colorOptions" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </div>
        <div class="comR" v-if="breed != '' && color != ''">
          <div class="comName2">星级</div>
          <div class="colon">:</div>
          <el-select v-model="levelId" clearable placeholder="请选择星级" size="small" style="width: 164px"
            :disabled="!$buttonAuthority('huoti-zongcang-message')" @change="levelChange">
            <el-option v-for="item in levelOptions" :key="item._id" :label="item.text" :value="item._id"></el-option>
          </el-select>
        </div>
      </div>
      <div class="com2">
        <div class="comL">
          <div class="comName2">芯片编号</div>
          <div class="colon">:</div>
          <el-input placeholder="请输入芯片编号" v-model="epromNo" clearable size="small" style="width: 164px"
            :disabled="!$buttonAuthority('huoti-zongcang-message')"></el-input>
        </div>
        <div class="comR">
          <div class="comName2">窝次号</div>
          <div class="colon">:</div>
          <el-input placeholder="请输入脖圈编号" v-model="nestNo" @input="handleInput" clearable size="small"
            style="width: 164px" :disabled="!$buttonAuthority('huoti-zongcang-message')"></el-input>
        </div>
      </div>
      <div class="com2">
        <div class="comL">
          <div class="comName2">体重</div>
          <div class="colon">:</div>
          <el-input placeholder="请输入体重" v-model="weight" clearable size="small" style="width: 164px"
            :disabled="!$buttonAuthority('huoti-zongcang-message')"></el-input>
        </div>
        <div class="comR">
          <div class="comName2">脖圈编号</div>
          <div class="colon">:</div>
          <el-input placeholder="请输入脖圈编号" v-model="insideNo" clearable size="small" style="width: 164px"
            disabled></el-input>
        </div>
      </div>
      <div class="com3">
        <div class="comName2">特征</div>
        <div class="colon">:</div>
        <el-select v-model="customFeatures" multiple placeholder="请选择特征" style="flex: 1" size="small"
          :disabled="!$buttonAuthority('huoti-zongcang-message')">
          <el-option v-for="item in customFeaturesOptions" :key="item.name" :label="item.name"
            :value="item.name"></el-option>
        </el-select>
      </div>
      <div class="com4">
        <div class="comName2">备注</div>
        <div class="colon">:</div>
        <el-input type="textarea" :rows="3" placeholder="请输入备注" v-model="remark" resize="none"
          :disabled="!$buttonAuthority('huoti-zongcang-message')"></el-input>
      </div>
      <!-- <div class="com3">
        <div class="comName2">宠物状态</div>
        <div class="colon">:</div>
        <el-radio-group v-model="lifeStatus" :disabled="!$buttonAuthority('huoti-zongcang-message')">
          <el-radio :label="1">存活</el-radio>
          <el-radio :label="0">亡故</el-radio>
        </el-radio-group>
      </div> -->
      <!-- <div class="com4" v-if="lifeStatus == 0">
        <div class="comName2">亡故原因</div>
        <div class="colon">:</div>
        <el-input type="textarea" :rows="3" placeholder="请输入亡故原因" v-model="deathReason" resize="none"
          :disabled="!$buttonAuthority('huoti-zongcang-message')"></el-input>
      </div> -->
      <!-- 特价 -->
      <div class="com3">
        <div class="comName2">特价宠物</div>
        <div class="colon">:</div>
        <el-radio-group v-model="specialType" :disabled="!$buttonAuthority('huoti-zongcang-price')">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </div>
      <div class="com3" v-if="specialType == 1">
        <div class="comName2">特价价格</div>
        <div class="colon">:</div>
        <el-input placeholder="请输入价格" v-model="price" clearable size="small" style="width: 164px"
          :disabled="!$buttonAuthority('huoti-zongcang-price')"></el-input>
      </div>
      <div class="com3" v-if="specialType == 0">
        <div class="comName2">百天服务价</div>
        <div class="colon">:</div>
        <el-input placeholder="请输入百天服务价" v-model="differPrice" clearable size="small" style="width: 164px"
          :disabled="!$buttonAuthority('huoti-zongcang-price')"></el-input>
          <div style=" font-weight: bold;font-size: 15px; color: #999999; margin-left: 20px">范围为 {{ lowestDifferPrice }} - {{ highestDifferPrice }}</div>
      </div>

    </div>
    <div class="shu"></div>
    <div class="pageR">
      <div class="pageTitle">疫苗记录</div>
      <div class="com3">
        <div class="comName2">疫苗</div>
        <div class="colon">:</div>
        <el-radio-group v-model="immunization" @change="handelChange">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </div>
      <!-- 表格 -->
      <el-table :data="vaccinesInfo" style="width: 100%; margin-top: 16px" v-if="immunization == 1">
        <el-table-column prop="planName" label="计划名称" width="80"></el-table-column>
        <el-table-column prop="planDate" label="计划日期" width="150">
          <template slot-scope="scope">
            <el-date-picker v-model="scope.row.planDate" type="date" placeholder="选择日期" size="small"
              style="width: 140px" :disabled="!$buttonAuthority('huoti-zongcang-yimiao')"></el-date-picker>
          </template>
        </el-table-column>
        <el-table-column prop="insideName" label="是否完成">
          <template slot-scope="scope">
            <el-select v-model="scope.row.isFinish" size="small" :disabled="!$buttonAuthority('huoti-zongcang-yimiao')">
              <el-option v-for="item in booleanData" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="参考天数">
          <template slot-scope="scope">{{
            scope.row.defaultIntervalDays == 0
              ? "--"
              : scope.row.defaultIntervalDays
          }}天</template>
        </el-table-column>
      </el-table>
      <div class="btn" @click="handelConfirmClick">
        {{ tab == 0 ? "确认" : "保存" }}
      </div>
    </div>
  </div>
</template>

<script>
import { uploadImg } from "../../../api/stockApi.js";
import {
  breed,
  colors,
  levels,
  customFeatures,
  simpleadd,
  editmodel,
} from "@/api/purchaseApi.js";
export default {
  props: {
    tab: {
      type: Number,
      default: 0,
    },
    id: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      cover: "", //头像
      insideName: "", //宠物昵称
      applyType: 1, //种类
      apply: 'C',
      sex: 0, //性别
      X: '',
      bron: '',
      bronDate: "", //出生日期
      breed: "", //品种
      breedOptions: [], //品种数据
      color: "", //颜色
      colorOptions: [], //颜色数据
      levelId: "", //星级
      levelOptions: [], //星级数据
      epromNo: "", //芯片编号
      insideNo: "", //脖圈号
      nestNo: '',
      weight: "0", //体重
      customFeatures: [], //特征
      customFeaturesOptions: [], //特征数据
      // lifeStatus: 1, //状态
      remark: "", //备注
      deathReason: "", //死亡原因
      immunization: 0, //疫苗状态
      price: "0",//特价价格
      differPrice: "0",//百天服务价
      lowestDifferPrice: "0",//百天服务最低价
      highestDifferPrice: "0",//百天服务最高价
      specialType: 0,//特价宠物
      booleanData: [
        {
          label: "是",
          value: true,
        },
        {
          label: "否",
          value: false,
        },
      ],

      vaccinesInfo: [],
      copyVacc: [
        {
          planName: "第一针",
          planDate: "",
          isFinish: false,
          defaultIntervalDays: 21,
          order: 1,
        },
        {
          planName: "第二针",
          planDate: "",
          isFinish: false,
          defaultIntervalDays: 21,
          order: 2,
        },
        {
          planName: "第三针",
          planDate: "",
          isFinish: false,
          defaultIntervalDays: 7,
          order: 3,
        },
        {
          planName: "狂犬疫苗",
          planDate: "",
          isFinish: false,
          defaultIntervalDays: 0,
          order: 4,
        },
      ],
      backData: null, //返回数据
      backDisabled: false, //禁用状态
    };
  },
  watch: {

  },
  mounted() {
    console.log(this.tab, 'this.tab');

    if (this.tab == 9 || this.tab == 10) {

      this.getEditmodelData();
      this.getCustomFeaturesData();
    } else {
      console.log(this.tab, '??98798798');
      if (this.applyType == '1') {
        this.apply = 'C'
      }
      this.X = '0'
      this.bron = '000000'
      this.insideNo = this.apply + this.bron + this.X + this.nestNo
      this.getBreedData();
      this.getCustomFeaturesData();
    }
  },
  methods: {
    handleInput(event) {
      this.nestNo = event
      if (this.applyType == 1) {
        this.apply = 'C'
      } else {
        this.apply = 'D'
      }
      if (this.sex == 1) {
        this.X = '1'
      } else if (this.sex == 2) {
        this.X = '2'
      } else {
        this.X = '0'
      }
      console.log(this.X, 'this.X this.X ');
      if (this.bronDate == '') {
        this.bron = '000000'
      } else {
        this.bron = (this.$public.timestampToTime(this.bronDate)).substring(2)
      }
      this.insideNo = this.apply + this.bron + this.X + this.nestNo

      // 你可以在这里处理输入事件
    },
    handelChange() {
      if (this.immunization == 1 && this.vaccinesInfo.length == 0) {
        this.vaccinesInfo = this.copyVacc;
      }
    },
    //获取编辑信息
    getEditmodelData() {
      let that = this;
      let params = {
        petId: this.id,
      };
      editmodel(params).then((res) => {
        console.log("模板信息", res);
        if (res.code == 0) {
          res = res.data;
          this.backData = res;
          that.cover = res.cover;
          that.insideName = res.insideName;
          that.applyType = Number(res.applyType);
          this.getBreedData();
          if (res.sex == "公") {
            that.sex = 1;
          } else {
            that.sex = 2;
          }
          that.bronDate = new Date(res.bronDate * 1000);
          that.breed = res.categoryInfo._id;
          that.getColorData();
          that.color = res.color;
          this.getLevelData();
          that.levelId = res.levelId;
          that.epromNo = res.epromNo;
          that.insideNo = res.insideNo;
          that.weight = res.weight;
          that.customFeatures = res.customFeatures;
          // that.lifeStatus = res.lifeStatus;
          that.specialType = res.specialType;
          that.price = res.price;
          that.differPrice = res.differPrice;
          that.lowestDifferPrice = res.lowestDifferPrice;
          that.highestDifferPrice = res.highestDifferPrice;
          that.remark = res.remark;
          that.deathReason = res.deathReason;
          that.immunization = res.immunization;
          that.nestNo = res.nestNo;
          console.log(res.vaccinesInfo);

          if (res.vaccinesInfo.length == 0) {
            that.vaccinesInfo = this.copyVacc;
          } else {
            for (let i = 0; i < res.vaccinesInfo.length; i++) {
              res.vaccinesInfo[i].planDate = new Date(
                res.vaccinesInfo[i].planDate * 1000
              );
            }

            that.vaccinesInfo = res.vaccinesInfo;
            this.backDisabled = true;
          }

          for (let j = 0; j < res.vaccinesInfo.length; j++) {
            if (
              res.vaccinesInfo[j].planDate ==
              "Thu Jan 01 1970 08:00:00 GMT+0800 (中国标准时间)"
            ) {
              res.vaccinesInfo[j].planDate = "";
            }
          }
        }
      });
    },
    //确认
    handelConfirmClick() {
      // console.log(this.weight);
      let that = this;
      if (this.breed == "") {
        this.$message({
          type: "error",
          message: "请选择品种",
        });
        return;
      }
      if (this.color == "") {
        this.$message({
          type: "error",
          message: "请选择颜色",
        });
        return;
      }
      if (this.levelId == "") {
        this.$message({
          type: "error",
          message: "请选择星级",
        });
        return;
      }
      if (this.epromNo == "") {
        this.$message({
          type: "error",
          message: "请输入芯片编号",
        });
        return;
      }
      if (this.nestNo == "") {
        this.$message({
          type: "error",
          message: "请输入窝次号",
        });
        return;
      }
      if (this.price == "") {
         this.price="0";
      }
      if(this.differPrice<this.lowestDifferPrice || this.differPrice>this.highestDifferPrice){
        this.$message({
          type: "error",
          message: "您输入的百天服务价不在范围内请重新输入",
        });
        return;
      }
      if (this.immunization == 1) {
        for (let i = 0; i < this.vaccinesInfo.length; i++) {
          if (this.vaccinesInfo[i].planDate == "") {
            this.$message({
              type: "error",
              message: "请填写完整疫苗信息",
            });
            return;
          }
        }
      }
      let params = {
        applyType: that.applyType,
        sex: that.sex,
        color: that.color,
        bronDate: new Date(that.bronDate).getTime() / 1000,
        insideNo: that.insideNo,
        nestNo: that.nestNo,
        insideName: that.insideName,
        levelId: that.levelId,
        cover: that.cover,
        immunization: that.immunization,
        weight: that.weight,
        remark: that.remark,
        epromNo: that.epromNo,
        customFeatures: that.customFeatures,
        // lifeStatus: that.lifeStatus,
        deathReason: that.deathReason,
        vaccinesInfo: [],
        specialType: that.specialType,
        price: that.price,
        differPrice:that.differPrice,
      };
      if (that.sex == 1) {
        params.sex = "公";
      } else {
        params.sex = "母";
      }
      for (let j = 0; j < that.breedOptions.length; j++) {
        if (this.breed == that.breedOptions[j]._id) {
          params.categoryInfo = that.breedOptions[j];
        }
      }
      if (that.immunization == 1) {
        for (let i = 0; i < that.vaccinesInfo.length; i++) {
          if (that.vaccinesInfo[i].planDate == "") {
            this.$message({
              type: "error",
              message: `请添加${that.vaccinesInfo[i].planName}时间`,
            });
            return;
          } else {
            params.vaccinesInfo[i] = {};
            params.vaccinesInfo[i].planDate =
              new Date(that.vaccinesInfo[i].planDate).getTime() / 1000;
            params.vaccinesInfo[i].planName = that.vaccinesInfo[i].planName;
            params.vaccinesInfo[i].isFinish = that.vaccinesInfo[i].isFinish;
            params.vaccinesInfo[i].defaultIntervalDays =
              that.vaccinesInfo[i].defaultIntervalDays;
            params.vaccinesInfo[i].order = that.vaccinesInfo[i].order;
          }
        }
      } else {
        params.vaccinesInfo = [];
      }

      if (that.tab == 9 || that.tab == 10) {
        params.petId = that.id;
      }
      simpleadd(params).then((res) => {
        if (res.code == 0) {
          console.log("添加宠物", res);
          if (that.tab == 0) {
            that.$message({
              type: "success",
              message: "添加成功!",
            });
            that.deletePetData();
          } else if (that.tab == 9) {
            that.$message({
              type: "success",
              message: "更新成功!",
            });
            setTimeout(() => {
              that.getEditmodelData();
            }, 500)
            this.$emit("reset");
          }
        }
      });
    },
    // 添加成功后清空所有数据
    deletePetData() {
      this.cover = "";
      this.insideName = "";
      this.applyType = 1;
      this.sex = 1;
      this.bronDate = "";
      this.breed = "";
      this.color = "";
      this.levelId = "";
      this.epromNo = "";
      this.insideNo = "";
      this.nestNo = "";
      this.weight = "";
      this.customFeatures = [];
      // this.lifeStatus = 1;
      this.remark = "";
      this.deathReason = "";
      this.immunization = 0;
      this.vaccinesInfo = [
        {
          planName: "第一针",
          planDate: "",
          isFinish: false,
          isDefaultCurrentDate: false,
          defaultIntervalDays: 21,
          order: 1,
        },
        {
          planName: "第二针",
          planDate: "",
          isFinish: false,
          isDefaultCurrentDate: false,
          defaultIntervalDays: 21,
          order: 2,
        },
        {
          planName: "第三针",
          planDate: "",
          isFinish: false,
          isDefaultCurrentDate: false,
          defaultIntervalDays: 7,
          order: 3,
        },
        {
          planName: "狂犬疫苗",
          planDate: "",
          isFinish: false,
          isDefaultCurrentDate: false,
          defaultIntervalDays: 0,
          order: 4,
        },
      ];
      this.getBreedData();
    },
    //选择星级
    levelChange(e){
        let that=this
        let obj=that.levelOptions.filter(item=>item._id==e)[0]
          that.lowestDifferPrice = obj.lowest_differ_price;
          that.highestDifferPrice = obj.differ_price;
    },
    //特征
    getCustomFeaturesData() {
      let that = this;
      let params = {
        type: "宠物特征",
        class: "服务字典",
      };
      customFeatures(params).then((res) => {
        console.log("特征", res);
        if (res.code == 0) {
          that.customFeaturesOptions = res.data.data;
        }
      });
    },
    //获取星级
    getLevelData() {
      let that = this;
      let params = {
        categoryId: this.breed,
        color: this.color,
      };
      levels(params).then((res) => {
        if (res.code == 0) {
          console.log(res.data);
          that.levelOptions = res.data;
        }
      });
    },
    //切换颜色
    colorChange() {
      if (this.color != "") {
        this.levelId = "";
        this.getLevelData();
      }
    },
    //获取颜色
    getColorData() {
      let that = this;
      let params = {
        categoryId: this.breed,
      };
      colors(params).then((res) => {
        if (res.code == 0) {
          console.log("颜色", res);
          that.colorOptions = res.data;
        }
      });
    },
    //切换品种
    breedChange() {
      if (this.breed != "") {
        this.color = "";
        this.getColorData();
      }
    },
    //切换种类
    applyTypeChange(e) {
      this.breed = "";
      if (e == 1) {
        this.apply = 'C'
      } else if (e == 2) {
        this.apply = 'D'
      }
      if (this.bronDate == '') {
        this.bron = '000000'
      } else {
        this.bron = (this.$public.timestampToTime(this.bronDate)).substring(2)
      }
      this.insideNo = this.apply + this.bron + this.X + this.nestNo
      this.getBreedData();
    },
    bronChange(e) {
      this.bron = (this.$public.timestampToTime(e)).substring(2)
      if (this.sex) {
        this.X = this.sex
      }
      this.insideNo = this.apply + this.bron + this.X + this.nestNo
      console.log(e, 'eee');
    },
    sexChange(e) {
      if (e == 1) {
        this.X = '1'
      } else if (e == 2) {
        this.X = '2'
      } else {
        this.X = '0'
      }

      if (this.bronDate == '') {
        this.bron = '000000'
      } else {
        this.bron = (this.$public.timestampToTime(this.bronDate)).substring(2)
      }
      this.insideNo = this.apply + this.bron + this.X + this.nestNo
    },
    //获取品种
    getBreedData() {
      let that = this;
      let params = {
        applyType: this.applyType,
      };
      breed(params).then((res) => {
        if (res.code == 0) {
          console.log("品种", res);
          that.breedOptions = res.data;
        }
      });
    },
    //上传封面图
    uploadCoverImg(item) {
      console.log("111图片", item);
      var formData = new FormData();
      formData.append("img", item.file);
      uploadImg(formData).then((res) => {
        if (res.code == 0) {
          this.cover = res.data.url;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  min-height: 722px;
  background: #fff;
  margin-top: 12px;
  font-size: 14px;
  padding: 20px;
  display: flex;

  .shu {
    height: 684px;
    width: 1px;
    background: #d8d8d8;
    margin: auto 0;
  }

  .pageL {
    min-width: 513px;
    padding-right: 20px;

    .view {
      display: flex;

      .viewR {
        margin-left: 20px;
        flex: 1;

        .petName {
          display: flex;
          align-items: center;
          margin-bottom: 28px;
        }
      }

      // 上传图片
      .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
      }

      .avatar-uploader .el-upload:hover {
        border-color: #409eff;
      }

      .avatar-uploader-icon {
        border: 1px dashed #d9d9d9;
        width: 92px;
        height: 92px;
        // background: #979797;
        line-height: 92px;
        text-align: center;
        color: #8c939d;
      }

      .avatar {
        width: 92px;
        height: 92px;
        display: block;
        object-fit: cover;
      }
    }
  }

  .pageR {
    flex: 1;
    padding-left: 20px;
    position: relative;
  }

  .btn {
    position: absolute;
    width: 155px;
    background: #f5882a;
    line-height: 40px;
    text-align: center;
    color: #fff;
    right: 0;
    bottom: 0;
    cursor: pointer;
  }

  .pageTitle {
    line-height: 22px;
    font-size: 16px;
    font-weight: bold;
    color: #333;
    margin-bottom: 12px;
  }

  .com1 {
    display: flex;
    justify-content: space-between;

    .comL {
      display: flex;
      align-items: center;
    }

    .comR {
      display: flex;
      align-items: center;
    }
  }

  .com2 {
    display: flex;
    justify-content: space-between;
    margin-top: 17px;

    .comL {
      flex: 1;
      margin-right: 38px;
      display: flex;
      align-items: center;
    }

    .comR {
      flex: 1;
      display: flex;
      align-items: center;
    }
  }

  .com3 {
    display: flex;
    margin-top: 17px;
    align-items: center;
  }

  .com4 {
    display: flex;
    margin-top: 17px;
  }

  .colon {
    margin-right: 8px;
  }

  .comName {
    height: 100%;
    min-width: 70px;
    text-align: justify;
    text-align-last: justify;
  }

  .comName2 {
    min-width: 70px;
    text-align: justify;
    text-align-last: justify;
  }
}
</style>
